/**
 * Created by USER on 18/5/28.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Button, Modal, message} from 'antd';
import { translate } from 'react-i18next';
import {Link} from 'react-router-dom';
import {sha256} from 'js-sha256';
import bs58 from 'bs58';
import {changeBarState} from '../redux/actions/headerbar_action';
import {paymentData, paymentQrcode} from '../redux/actions/payment_action';
import ImgList from '../images/img';
import httpClient from '../swagger/swagger';

const { client, setAccesskey } = httpClient;

class PaymentPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentMethod: 'alipay',
      jump: false,
      verificationModal: false,
      price: 0,
      orderData: {
        buy_amount: 1,
        notice_mobile: 'N/A',
        order_number: 'N/A',
        order_price: 'N/A',
        order_remark: 'N/A',
        order_shipping_address: {name: 'N/A', address: 'N/A', mobile: 'N/A'},
        product_title: 'N/A',
        receipt_type_code: 'N/A',
      }
    };
  }
  componentWillMount() {
    this.props.dispatch(changeBarState('product'));
    client.then((oclient) => { // 请求商品的详细信息
      oclient.apis.product.get_v1_product_id({
        id: 1
      }).then((res) => {
        if (res.obj.code !== 200) {
          message.error(res.obj.message);
        } else {
          this.setState({
            price: res.obj.data.price,
          });
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
  }

  componentDidMount() {
    if (JSON.parse(window.localStorage.getItem('order')) !== null) {
      const {order} = JSON.parse(window.localStorage.getItem('order'));
      setAccesskey(this.makeToken()).then(() => {
        client.then((oclient) => {
          oclient.apis.order.get_v1_order_id({ // 请求订单的详细信息
            id: order,
          }).then((result) => {
            if (result.obj.code === 200) {
              this.setState({
                orderData: result.obj
              });
              this.props.dispatch(paymentData(result.obj));
              if (result.obj.status === 1) {
                this.props.history.push('/product/payment/payment_complete');
              }
              if (result.obj.paymethod !== null) {
                this.setState({
                  verificationModal: true
                });
              }
            } else {
              message.error(this.props.t('get_order_fail'));
            }
          }).catch(() => message.error(this.props.t('request_error')));
        }).catch(() => message.error(this.props.t('request_error')));
      }).catch(() => {});
    } else {
      this.props.history.push('/product');
    }
  }

  makeToken() { // 配置请求的token 防止入侵
    const {notice_mobile} = JSON.parse(window.localStorage.getItem('order'));
    const mobileSha = sha256(sha256.digest(notice_mobile));
    const timestamp = parseInt(new Date().getTime() / 1000, 10).toString();
    const another = mobileSha.slice(timestamp.length);
    let token = '';
    for (let i = 0; i < timestamp.length; i++) {
      token += mobileSha[i] + timestamp[i];
    }
    const bytes = Buffer.from(token + another, 'hex');
    return bs58.encode(bytes);
  }


  choosePaymentMethod(paymentMethod) { // 选择支付的方式
    this.setState({
      paymentMethod
    });
  }

  goToPay() { // 不同的支付方式以及不同的设置，执行不同
    const {orderData, paymentMethod} = this.state;
    const win = window.open('/loading');

    setAccesskey(this.makeToken()).then(() => {
      client.then((oclient) => {
        oclient.apis.payment.get_v1_payment({
          id: orderData.order_number,
          paymethod: paymentMethod,
          h5: /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)
        }).then((result) => {
          if (result.obj.code === 200) {
            if (!/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent) && paymentMethod === 'wechat') {
              this.props.dispatch(paymentQrcode(result.obj.pay_url));
              window.localStorage.setItem('wechatQrcode', result.obj.pay_url)
              win.location.href = './product/payment/wechat';
            } else {
              win.location.href = result.obj.pay_url;
            }

            this.setState({
              // jump: true,
              verificationModal: true
            });

            const timer = setInterval(() => {
              if (win.closed) {
                clearInterval(timer);
                this.paymentComplete();
              }
            }, 1000);
          } else {
            setTimeout(() => {
              win.close();
              message.error(result.obj.message);
            }, 1000);
          }
        }).catch(() => message.error(this.props.t('request_error')));
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => {});
  }

  handleCancel() { // 支付提示弹窗的关闭
    this.setState({
      verificationModal: false
    });
  }

  paymentComplete() {// 请求订单是否支付
    const {order} = JSON.parse(window.localStorage.getItem('order'));
    setAccesskey(this.makeToken()).then(() => {
      client.then((oclient) => {
        oclient.apis.order.get_v1_order_id_ispay({
          id: order,
        }).then((result) => {
          if (result.obj.code === 200) {
            if (result.obj.ispay) {
              this.props.history.push('/product/payment/payment_complete');
            } else {
              message.error(this.props.t('payment_un_complete'));
            }
          } else {
            message.error(result.obj.message);
          }
        }).catch(() => message.error(this.props.t('request_error')));
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => {});
  }

  paymentQuestion() {
    this.setState({
      verificationModal: false
    });
  }
  render() {
    const { t } = this.props;
    const {price, paymentMethod, orderData} = this.state;
    const borderStyle = {border: '2px solid #0085ff'};
    return (
      <div>
        <div className="payment_page">
          <div className="order_success_system">
            <div className="order_success_system_icon">
              <i className="icon iconfont icon-ordersus" />
            </div>
            <div className="order_success_system_title">
              {t('payment_order_success')}
            </div>
            <div className="order_success_system_num">
              <span>{t('payment_order')}</span>
              <span> {orderData.order_number}</span>
            </div>
            <div className="order_success_system_note">
              {t('payment_order_notice')}
            </div>
          </div>
          <div className="statements">
            <div className="statements_order_num">{orderData.order_number}</div>
            <div className="statements_details">
              <div className="statements_product">
                <div className="statements_details_title">
                  {t('payment_product_name')}
                </div>
                <div className="statements_product_details">
                  <img src={ImgList.img.productImg[0]} alt="LUBANSO" />
                  <span>LUBANSO X1</span>
                  <span>￥ {price}</span>
                  <span>x {orderData.buy_amount}</span>
                  <span>{orderData.coupon_price ? `-${orderData.coupon_price}` : ''}</span>
                  <span>￥ {orderData.order_price}</span>
                </div>
              </div>
              <div className="statements_address">
                <div className="statements_details_title">
                  <span>{t('payment_address')}</span>
                </div>
                <div className="statements_address_details">
                  <div>
                    <span>{orderData.order_shipping_address.address}</span>
                    <span>{orderData.order_shipping_address.mobile}</span>
                  </div>
                </div>
                <div className="statements_details_title">
                  <span> <span>{t('payment_delivery')}</span></span>
                </div>
                <div className="statements_address_details">
                  <span>{orderData.notice_mobile}</span>
                </div>
              </div>
              {
                t('language') === 'zh' ?
                  <div className="statements_invoice_note" style={{display: orderData.receipt_type_code !== null ? 'block' : 'none'}}>
                    <div className="statements_details_title">开票信息</div>
                    <div style={{display: orderData.receipt_type_code === 1 ? 'block' : 'none'}}>您选择了普通发票，将会随商品一起邮寄</div>
                    <div style={{display: orderData.receipt_type_code === 0 ? 'block' : 'none'}}>您选择了电子发票，付款完成后会发送至您的邮箱</div>
                  </div> : false
              }
            </div>
            <div className="mobile_statements_details">
              <div className="statements_product">
                <div className="statements_details_title">
                  {t('payment_product_name')}
                </div>
                <div className="mobile_statements_product_details">
                  <div>
                    <img src={ImgList.img.productImg[0]} alt="LUBANSO" />
                  </div>
                  <div>
                    <p>lubanso X1</p>
                    <div className="mobile_statements_statitics">
                      <span>￥ {price}</span>
                      <span>x {orderData.buy_amount}</span>
                      <span>￥ {orderData.order_price}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mobile_statements_address">
                <div className="statements_details_title">
                  {t('payment_address')}
                </div>
                <div className="statements_address_details">
                  <div>{orderData.order_shipping_address.address}</div>
                  <div>{orderData.order_shipping_address.mobile}</div>
                </div>
              </div>
              <div className="mobile_statements_address">
                <div className="statements_details_title">
                  {t('payment_delivery')}
                </div>
                <div className="statements_address_details">
                  <div>{orderData.notice_mobile}</div>
                </div>
              </div>
              {
                t('language') === 'zh' ?
                  <div className="statements_invoice_note" style={{display: orderData.receipt_type_code !== null ? 'block' : 'none'}}>
                    <div className="statements_details_title">开票信息</div>
                    <div style={{display: orderData.receipt_type_code === 1 ? 'block' : 'none'}}>您选择了普通发票，将会随商品一起邮寄</div>
                    <div style={{display: orderData.receipt_type_code === 0 ? 'block' : 'none'}}>您选择了电子发票，付款完成后会发送至您的邮箱</div>
                  </div> : false

              }
            </div>
          </div>
          <div className="payment_method">
            <div className="payment_method_title">
              {t('payment_chose_pay')}
            </div>
            <div className="payment_method_details">
              <div
                onClick={() => this.choosePaymentMethod('alipay')}
                onKeyPress={() => this.choosePaymentMethod('alipay')}
                style={paymentMethod === 'alipay' ? borderStyle : {}}
              >
                <img src={ImgList.img.aliPay} alt="LUBANSO" />
              </div>
              <div
                onClick={() => this.choosePaymentMethod('bitpay')}
                onKeyDown={() => this.choosePaymentMethod('bitpay')}
                style={paymentMethod === 'bitpay' ? borderStyle : {}}
              >
                <img src={ImgList.img.bitPay} alt="LUBANSO" />
              </div>
              <div
                onClick={() => this.choosePaymentMethod('wechat')}
                onKeyDown={() => this.choosePaymentMethod('wechat')}
                style={paymentMethod === 'wechat' ? borderStyle : {}}
              >
                <img src={ImgList.img.wechatPay} alt="LUBANSO" />
              </div>
            </div>
            <div className="payment_button_area">
              <Link
                onClick={(e) => {
                  if (!this.state.jump) e.preventDefault();
                }}
                to="/product/payment/payment_complete"
              >
                <Button className="button_style payment_button" onClick={() => this.goToPay()}>{t('go_to_pay')}</Button>
              </Link>
              <Modal
                title=""
                visible={this.state.verificationModal}
                footer={null}
                wrapClassName="vertical-center-modal"
                onCancel={() => this.handleCancel()}
                closable={false}
                destroyOnClose={true}
              >
                <div className="payment_modal">
                  <div className="payment_modal_title">{t('payment_modal_title')}</div>
                  <div className="payment_modal_details">{t('payment_modal_notice')}</div>
                  <div className="payment_modal_button">
                    <Button onClick={() => this.paymentComplete()}>{t('payment_modal_button1')}</Button>
                    <Button onClick={() => this.paymentQuestion()}>{t('payment_modal_button2')}</Button>
                  </div>
                </div>
              </Modal>
            </div>
          </div>
        </div>
        <div className="mobile_order_question">
          <div className="mobile_order_question_title">{t('payment_question')}</div>
          <div className="mobile_all_question">
            <div className="mobile_single_question">
              <div className="mobile_single_question_title">
                {t('payment_question1')}
              </div>
              <div className="mobile_single_question_details">
                {t('payment_question1_details')}
              </div>
            </div>
            <div className="mobile_single_question">
              <div className="mobile_single_question_title">
                {t('payment_question2')}
              </div>
              <div className="mobile_single_question_details">
                {t('payment_question2_details')}
              </div>
            </div>
            <div className="mobile_single_question">
              <div className="mobile_single_question_title">
                {t('payment_question3')}
              </div>
              <div className="mobile_single_question_details">
                {t('payment_question3_details1')}
                <Link to={{pathname: '/about', state: 'afterSales'}}>
                  {t('payment_question3_details2')}
                </Link>
                {t('payment_question3_details3')}
              </div>
            </div>
          </div>
        </div>
        <div className="web_order_question">
          <div className="web_order_question_title">{t('payment_question')}</div>
          <div className="web_all_question">
            <div className="web_single_question">
              <div className="web_single_question_title">
                {t('payment_question1')}
              </div>
              <div className="web_single_question_details">
                {t('payment_question1_details')}
              </div>
            </div>
            <div className="web_single_question">
              <div className="web_single_question_title">
                {t('payment_question2')}
              </div>
              <div className="web_single_question_details">
                {t('payment_question2_details')}
              </div>
            </div>
            <div className="web_single_question">
              <div className="web_single_question_title">
                {t('payment_question3')}
              </div>
              <div className="web_single_question_details">
                {t('payment_question3_details1')}
                <Link to={{pathname: '/about', state: 'afterSales'}}>
                  {t('payment_question3_details2')}
                </Link>
                {t('payment_question3_details3')}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function select(state) {
  return {
    appBarReducer: state.appBarReducer,
    addressInformationReducer: state.addressInformationReducer,
    paymentReducer: state.paymentReducer
  };
}

const PaymentPageTranslate = translate('translations')(PaymentPage);

export default connect(select)(PaymentPageTranslate);

